import React, { useEffect } from "react";
import AddEmployee from "../../components/admin/AddEmployee";

const AddEmployeePage = () => {

    useEffect(() => {
        document.body.id = "addEmployee-002";
      }, []);

  return (
    <div>
     <AddEmployee />
    </div>
  );
};

export default AddEmployeePage;  
